export default __webpack_public_path__ + "static/media/image_5.4f5b1aec.jpg";